<div class="editor">
  <angular-markdown-editor
    class="markdown-editor"
    [textareaId]="textareaId"
    [(ngModel)]="prompt"
    [options]="editorOptions"
    (onFullscreenExit)="hidePreview()"
    (onChange)="onChange($event.detail.eventData)"
  >
  </angular-markdown-editor>
</div>
